<template>
    <b-input-group
        data-cy="monetaryInput"
    >
        <template
            v-if="showPrepend"
            slot="prepend"
        >
            <b-input-group-text
                class="monetary-input"
            >
                <FontAwesomeIcon
                    :class="{'disabled': !monetaryValue}"
                    :icon="prependIcon"
                />
            </b-input-group-text>
        </template>

        <b-form-input
            v-model="input"
            class="border-left-0"
            data-cy="monetaryInputFormInput"
            :disabled="disabled"
            :formatter="formatCurrency"
            :placeholder="placeholder"
            @input="$emit('monetary-input-changed', $event)"
        />

        <template
            v-if="showAppend"
            slot="append"
        >
            <b-input-group-text>
                {{ appendText }}
            </b-input-group-text>
        </template>
    </b-input-group>
</template>

<script>
    import {library} from '@fortawesome/fontawesome-svg-core';
    import {faDollarSign} from '@fortawesome/pro-solid-svg-icons';
    import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

    library.add(
        faDollarSign,
    );

    import inputFilters from '../mixins/inputFilters';

    /**
     * @group Inputs
     * A text input with auto monetary formatting.
     */
    export default {
        name: 'MonetaryInput',
        components: {
            FontAwesomeIcon
        },
        mixins: [
            inputFilters,
        ],
        model: {
            prop: 'input',
            event: 'kc::monetaryinput::input'
        },
        props: {
            /**
             * The text to appear after the input.
             */
            appendText: {
                type: String,
                required: false,
                // `'.00'`
                default: '.00'
            },
            /**
             * Boolean of if the input is disabled.
             */
            disabled: {
                type: Boolean,
                required: false,
                // `false`
                default: false,
            },
            /**
             * The initial value of the input.
             */
            initialInput: {
                type: String,
                required: false,
                // `''`
                default: ''
            },
            /**
             * The placeholder text.
             */
            placeholder: {
                type: String,
                required: false,
                // `'Value'`
                default: 'Value',
            },
            /**
             * The `FontAwesomeIcon` name to appear before the input.
             */
            prependIcon: {
                type: String,
                required: false,
                // `'dollar-sign'`
                default: 'dollar-sign'
            },
            /**
             * Boolean of if the input should show the `appendText`.
             */
            showAppend: {
                type: Boolean,
                required: false,
                // `true`
                default: true,
            },
            /**
             * Boolean of if the input should show the `prependIcon`.
             */
            showPrepend: {
                type: Boolean,
                required: false,
                // `true`
                default: true,
            }
        },
        data() {
            return {
                input: this.initialInput,
            };
        },
        computed: {
            monetaryValue() {
                return this.input !== "";
            }
        }
    };
</script>
